import { html } from 'lit';
import { Umbrella } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-umbrella')
export class PdsIconUmbrella extends PdsIcon {
  @state()
  icon = Umbrella;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
